module.exports = __webpack_public_path__ + "ca84af47828f7f92d590632457092028.svg";